import { enableProdMode } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";
import {
    breadcrumbsIntegration,
    browserProfilingIntegration,
    browserTracingIntegration,
    dedupeIntegration,
    defaultStackParser,
    globalHandlersIntegration,
    init,
    linkedErrorsIntegration,
    makeFetchTransport,
    replayIntegration,
} from "@sentry/angular";
import { AppModule } from "src/app/app.module";
import { environment } from "src/environments";

init({
    enabled: environment.enableSentry === true,
    attachStacktrace: true,
    dsn: environment.sentryDsn,
    environment: environment.sentryEnv,
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: [
        browserProfilingIntegration(),
        browserTracingIntegration({
        }),
        globalHandlersIntegration(),
        breadcrumbsIntegration(),
        dedupeIntegration(),
        linkedErrorsIntegration(),
        replayIntegration({
            // NOTE: Mask all text content without input value. Additionally, to
            // ensure security, all inputs such as passwords will be completely
            // masked. For more information on configuring privacy settings, refer
            // to the https://github.com/getsentry/sentry-javascript/tree/develop/packages/replay-internal#privacy-configuration
            maskAllText: false,
            maskAllInputs: true,
            stickySession: true,
        }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^\//],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    profilesSampleRate: 1.0,
});


if (environment.production) {
    enableProdMode();
}

platformBrowser().bootstrapModule(AppModule)
    .catch(err => console.log(err));
